export default "/img/lock-yellow.png"